import { useSelfAssessmentWizardResult } from './SelfAssessmentWizardResult.hooks'
import { SelfAssessmentWizardResultUI } from './SelfAssessmentWizardResult.ui'

export const SelfAssessmentWizardResult = () => {
  const result = useSelfAssessmentWizardResult()

  return <SelfAssessmentWizardResultUI result={result} />
}
